import React, { Fragment } from "react";
import Footer from "../../component/Other/Footer";
import ProjectMap from "../../component/Map/ProjectMap";
import Navbar from "../../component/Other/Navbar";
import Pricing from "../../component/Other/Pricing";
const Index = (props) => {

  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="bg__black">
          <Navbar />
          <section className="landing-hero">
            <div className="container landing-hero__container">
              <div className="row align-items-center">
                <div className="col-lg-4 text-center text-sm-left landing-hero__copy">
                  <div className="wrapper__point justify-content-center justify-content-sm-start mb-3">
                    <div className="dot"></div>
                    <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024 landing-hero__eyebrow">Geo-Validated Project Operations</h5>
                  </div>
                  <h1 className="landing-hero__title bold color__white mt__5 md-0">Run Capital Projects <br className="d-none d-xl-block" />
                    With Proof Of Place</h1>
                  <p className="landing-hero__lead normal color__white mt-4 mb-0">PavilionManager is a multi-tenant platform for construction and capital projects where geo validation anchors every update to a real project location, so teams and sponsors can trust timeline checkpoints, task comments, chats and evidence.</p>
                </div>
                <div className="col-lg-8 mt-5 mt-lg-0 text-center text-lg-right landing-hero__visual-col pr-lg-0">
                  <div className="hero-mockup" role="img" aria-label="PavilionManager project dashboard preview">
                    <div className="hero-mockup__dots" aria-hidden="true"></div>
                    <svg className="hero-mockup__lines" viewBox="0 0 1024 820" preserveAspectRatio="none" aria-hidden="true">
                      <path d="M680 220 Q1000 340 760 580" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="1.2" />
                      <path d="M240 590 Q460 700 700 590" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="1.2" />
                      <circle cx="920" cy="255" r="5" fill="#2085d6" />
                      <circle cx="930" cy="420" r="5" fill="#2085d6" />
                      <circle cx="480" cy="640" r="5" fill="#2085d6" />
                    </svg>

                    <div className="hm-card hm-card--progress">
                      <div className="hm-row hm-row--head">
                        <span className="hm-icon">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M3 17l6-6 4 4 8-8" stroke="#2085d6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 7h7v7" stroke="#2085d6" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                        <span className="hm-title">Project Progress</span>
                      </div>
                      <div className="hm-big">68%</div>
                      <div className="hm-sub">Overall completion</div>
                      <div className="hm-progress"><span style={{ width: "68%" }}></span></div>
                      <div className="hm-row hm-row--foot">
                        <span className="hm-pill"><span className="hm-pill__arrow">&uarr;</span> 12%</span>
                        <span className="hm-meta">vs last month</span>
                      </div>
                    </div>

                    <div className="hm-card hm-card--upload">
                      <span className="hm-icon">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" stroke="#2085d6" strokeWidth="1.8" strokeLinejoin="round" />
                          <path d="M14 3v5h5" stroke="#2085d6" strokeWidth="1.8" strokeLinejoin="round" />
                          <path d="M9 13h6M9 17h4" stroke="#2085d6" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                      </span>
                      <div className="hm-stack">
                        <span className="hm-title">Recent Upload</span>
                        <span className="hm-link">Site_Inspection.pdf</span>
                        <span className="hm-meta">2m ago <span className="hm-sep">&middot;</span> by Sarah J.</span>
                      </div>
                    </div>

                    <div className="hm-card hm-card--chat">
                      <span className="hm-icon">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" stroke="#2085d6" strokeWidth="1.8" strokeLinejoin="round" />
                        </svg>
                      </span>
                      <div className="hm-stack">
                        <div className="hm-row hm-row--between">
                          <span className="hm-title">Project Chat</span>
                          <span className="hm-badge">2</span>
                        </div>
                        <span className="hm-meta">New message from David</span>
                        <span className="hm-msg">Can you please review<br />the latest drawing?</span>
                      </div>
                    </div>

                    <div className="hm-card hm-card--team">
                      <span className="hm-icon">
                        <svg viewBox="0 0 24 24" fill="none">
                          <circle cx="9" cy="8.5" r="3" stroke="#2085d6" strokeWidth="1.8" />
                          <path d="M3 19c0-3 2.7-4.5 6-4.5s6 1.5 6 4.5" stroke="#2085d6" strokeWidth="1.8" strokeLinecap="round" />
                          <circle cx="17" cy="9" r="2.4" stroke="#2085d6" strokeWidth="1.8" />
                          <path d="M14.5 18.5c.4-1.7 1.7-2.8 3-2.8s2.6 1 3 2.8" stroke="#2085d6" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                      </span>
                      <div className="hm-stack">
                        <span className="hm-title">Team On Site</span>
                        <span className="hm-big hm-big--sm">23</span>
                        <div className="hm-row hm-row--between">
                          <span className="hm-meta">of 28 today</span>
                          <span className="hm-avatars">
                            <span>AJ</span><span>MK</span><span>DS</span><span>+5</span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="hm-card hm-card--budget">
                      <span className="hm-icon">
                        <svg viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="#2085d6" strokeWidth="1.8" />
                          <path d="M8 7l8 10M8 12h8M8 15h8" stroke="#2085d6" strokeWidth="1.6" strokeLinecap="round" />
                        </svg>
                      </span>
                      <div className="hm-stack">
                        <span className="hm-title">Budget Used</span>
                        <span className="hm-big hm-big--sm">&#8358;3.45M</span>
                        <span className="hm-meta">of &#8358;5.20M</span>
                      </div>
                      <div className="hm-ring">
                        <svg viewBox="0 0 36 36" aria-hidden="true">
                          <circle cx="18" cy="18" r="15.9" fill="none" stroke="#e3eaf5" strokeWidth="3.6" />
                          <circle cx="18" cy="18" r="15.9" fill="none" stroke="#2085d6" strokeWidth="3.6" strokeDasharray="100 100" strokeDashoffset="34" strokeLinecap="round" transform="rotate(-90 18 18)" />
                        </svg>
                        <span className="hm-ring__label">66%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className="bg__blue">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm color__white">Trust Layer For Every Project Update</h2>
              <p className="normal font__size--16 text__16-1024 color__white mb-0">Submitted GPS is checked against each project site anchor so operational activity <br /> can be recorded with real location context.</p>
            </div>
            <div className="wrapper__list-archivment d-flex flex-wrap align-items-center justify-content-center">
              <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img src="./../images/award.png" alt="" />
                  <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">GPS</h5>
                </div>
                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Location <br /> submission</p>
              </div>
              <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img src="./../images/close-circle.png" alt="" />
                  <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">Site</h5>
                </div>
                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Anchor and <br /> radius check</p>
              </div>
              <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img src="./../images/star.png" alt="" />
                  <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">Proof</h5>
                </div>
                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">On-site or <br /> off-site status</p>
              </div>
              <div className="item mb-4 mb-xl-0 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <img src="./../images/happyemoji.png" alt="" />
                  <h5 className="mb-0 semi-bold font__size--40 text__40-1024 text__40-md text__40-mm color__white ml-3">Log</h5>
                </div>
                <p className="normal font__size--16 text__16-1024 color__white mb-0 ml-3">Audit trail <br /> for sponsors</p>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-5 text-center text-lg-left my-auto mb-5 mb-lg-0">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Multi-Project Visibility</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm ">Manage Multiple Projects <br className="d-none d-md-block" /> At Once</h1>
                <p className="normal font__size--16 text__16-1024 color__gray-2 mb-4">Give department heads and project managers a portfolio-level view of active work across teams, departments and locations. See where progress is moving, where deadlines are at risk and where resources need attention.</p>
                <ul className="list normal font__size--16 text__16-1024 color__gray-2 text-left d-inline-block">
                  <li>Monitor active projects across departments or remote locations</li>
                  <li>Review task status, milestones and project health at a glance</li>
                  <li>Coordinate team workload and resource allocation across projects</li>
                  <li>Spot deadline risk before it becomes scope creep</li>
                </ul>
              </div>
              <div className="col-lg-7">
                <div className="wrapper__card-included h-100">
                  <div className="wrapper__map-showcase">
                    <ProjectMap />
                  </div>
                  <div className="row mt-4">
                    <div className="col-md-4 mb-3 mb-md-0">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">Operations Team</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Milestones active, resources assigned, task updates pending.</p>
                    </div>
                    <div className="col-md-4 mb-3 mb-md-0">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">Product Team</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Sprint tasks, dependencies and milestone progress visible.</p>
                    </div>
                    <div className="col-md-4">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">Finance Team</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Budget tracking, project reports and time-to-completion insight.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-5 text-center text-lg-left my-lg-auto">
                <img src="./../images/geovalidation.png" alt="PavilionManager geo validation dashboard" />
              </div>
              <div className="col-lg-6 text-center text-lg-left my-auto">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Geo Validation</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm ">Verify Work Where <br className="d-none d-md-block" /> It Happens</h1>
                <p className="normal font__size--16 text__16-1024 color__gray-2 mb-4">PavilionManager helps teams connect project activity to real locations, making it easier to confirm attendance, validate field updates and keep location-based proof attached to the right project record.</p>
                <ul className="list normal font__size--16 text__16-1024 color__gray-2 text-left d-inline-block">
                  <li>Validate team check-ins against expected project locations</li>
                  <li>Keep location-aware updates tied to tasks and milestones</li>
                  <li>Improve accountability for remote and distributed teams</li>
                  <li>Support better visibility for managers reviewing project progress</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-5 text-center text-lg-left my-lg-auto">
                <img src="./../images/Content.png" alt="" />
              </div>
              <div className="col-lg-6 text-center text-lg-left my-auto">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Project Operations</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm ">Run Every Project From <br className="d-none d-md-block" /> One Workspace</h1>
                <p className="normal font__size--16 text__16-1024  color__gray-2 mb-4">Create projects, assign tasks to team members, define milestones <br className="d-none d-md-block" /> and track status, priority, progress and comments in real time <br className="d-none d-md-block" /> so everyone knows what to do next.</p>
                <a href="#!" className="btn btn__outlined--green font__size--16 text__16-1024 semi-bold color__black h__black no__opacity shadow rounded__50">Explore operations</a>
              </div>
            </div>
          </div>
        </section>

        <section className="bg__blue">
          <div className="container">
            <div className="text-center mb-5">
              <div className="wrapper__point justify-content-center mb-4">
                <div className="dot"></div>
                <h5 className="mb-0 ml-2 color__white semi-bold font__size--16 text__16-1024">Organization Layer</h5>
              </div>
              <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm color__white">Built Around Teams, Roles and Departments</h2>
              <p className="normal font__size--16 text__16-1024 color__white mb-0">Every team needs a clear way to organize work, communicate priorities and understand ownership. PavilionManager keeps projects, tasks, team members and department-level visibility in one shared workspace.</p>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="h-100 border rounded p-4">
                  <h5 className="bold font__size--20 text__20-1024 mb-2 color__white">Departments</h5>
                  <p className="normal font__size--16 text__16-1024 color__white mb-0">Organize projects by teams, business units or departments so leaders can track work clearly.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="h-100 border rounded p-4">
                  <h5 className="bold font__size--20 text__20-1024 mb-2 color__white">Team Members</h5>
                  <p className="normal font__size--16 text__16-1024 color__white mb-0">Assign responsibility, clarify ownership and keep everyone aligned on project priorities.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="h-100 border rounded p-4">
                  <h5 className="bold font__size--20 text__20-1024 mb-2 color__white">Managers</h5>
                  <p className="normal font__size--16 text__16-1024 color__white mb-0">Plan projects, monitor team progress, review analytics and keep deadlines on track.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="h-100 border rounded p-4">
                  <h5 className="bold font__size--20 text__20-1024 mb-2 color__white">Stakeholders</h5>
                  <p className="normal font__size--16 text__16-1024 color__white mb-0">Give department heads and business leaders better visibility into delivery progress.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 text-center text-lg-left order-lg-1 order-12 my-auto">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Resource And Budget Control</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm ">Plan Capacity, Budgets <br className="d-none d-md-block" /> and Deadlines</h1>
                <p className="normal font__size--16 text__16-1024  color__gray-2 mb-4">Allocate resources effectively, understand workload across teams <br className="d-none d-md-block" /> and track budget performance alongside time-to-completion so <br className="d-none d-md-block" /> projects stay organized and predictable.</p>
                <a href="#!" className="btn btn__outlined--green font__size--16 text__16-1024 semi-bold color__black h__black no__opacity shadow rounded__50">See planning tools</a>
              </div>
              <div className="col-lg-6 order-1 order-lg-12 mb-5 text-center text-lg-left my-lg-auto">
                <img src="./../images/sdadasd.png" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="text-center mb-5">
              <div className="wrapper__point justify-content-center mb-4">
                <div className="dot"></div>
                <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Delivery Lifecycle</h5>
              </div>
              <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm">Everything From Planning To Completion</h2>
              <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">PavilionManager keeps project activity, assignments, resources and progress visible so teams can move from planning to execution without losing context.</p>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Project Setup</h5>
                  <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                    <li>Create and manage departmental projects</li>
                    <li>Define project goals, scope and owners</li>
                    <li>Keep plans and supporting files in one workspace</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Milestones</h5>
                  <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                    <li>Track project timelines and key dates</li>
                    <li>Monitor milestone progress in real time</li>
                    <li>Reduce missed deadlines and scope creep</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Tasks</h5>
                  <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                    <li>Create tasks under milestones or projects</li>
                    <li>Track status, priority, progress and comments</li>
                    <li>Assign team members and track ownership</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Resource Planning</h5>
                  <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                    <li>Plan people, time and project capacity</li>
                    <li>Allocate resources based on priority</li>
                    <li>Keep workloads aligned with deadlines</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Shared Timeline</h5>
                  <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                    <li>Visualize progress against key project stages</li>
                    <li>Share updates across teams and departments</li>
                    <li>Keep decision history connected to the project</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Team Collaboration</h5>
                  <ul className="list normal font__size--16 text__16-1024 color__gray-2">
                    <li>Use shared workspaces for team execution</li>
                    <li>Support file sharing and real-time communication</li>
                    <li>Keep teams aligned across remote locations</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 mb-5 text-center text-lg-left my-lg-auto">
                <img src="./../images/fgfd.png" alt="" />
              </div>
              <div className="col-lg-6 text-center text-lg-left my-auto">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Workflow Management</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm ">Streamline Work Across <br className="d-none d-md-block" /> Every Department</h1>
                <p className="normal font__size--16 text__16-1024  color__gray-2 mb-4">Keep project plans, task ownership, shared files, team updates <br className="d-none d-md-block" /> and milestone progress connected so managers can reduce delays <br className="d-none d-md-block" /> and keep execution moving.</p>
                <a href="#!" className="btn btn__outlined--green font__size--16 text__16-1024 semi-bold color__black h__black no__opacity shadow rounded__50">View workflow tools</a>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-lg-6 text-center text-lg-left my-auto mb-5 mb-lg-0">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Team Collaboration</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm ">Bring Teams Together <br className="d-none d-md-block" /> Around The Work</h1>
                <p className="normal font__size--16 text__16-1024 color__gray-2 mb-4">Shared workspaces, file sharing and real-time communication help teams collaborate across departments, priorities and remote locations without losing project context.</p>
                <a href="#!" className="btn btn__outlined--green font__size--16 text__16-1024 semi-bold color__black h__black no__opacity shadow rounded__50">Explore collaboration</a>
              </div>
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-sm-6 mb-4">
                    <div className="wrapper__card-included h-100">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">Shared Workspaces</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Keep tasks, files and updates connected to each project.</p>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-4">
                    <div className="wrapper__card-included h-100">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">Communication</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Help teams coordinate decisions, blockers and progress.</p>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-4">
                    <div className="wrapper__card-included h-100">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">File Sharing</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Centralize supporting documents and project materials.</p>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-4">
                    <div className="wrapper__card-included h-100">
                      <h5 className="bold font__size--20 text__20-1024 mb-2">Remote Teams</h5>
                      <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Keep distributed departments aligned around deadlines.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg__blue">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 text-center text-lg-left mb-5 mb-lg-0">
                <div className="wrapper__point justify-content-center justify-content-lg-start mb-3">
                  <div className="dot"></div>
                  <h5 className="mb-0 ml-2 color__white semi-bold font__size--16 text__16-1024">Portfolio Analytics</h5>
                </div>
                <h1 className="bold font__size--40 text__40-1024 text__40-md text__40-mm color__white">Know Where Attention <br className="d-none d-md-block" /> Is Needed</h1>
                <p className="normal font__size--16 text__16-1024 color__white mb-0">Project analytics help teams understand performance, budget tracking, resource pressure and time-to-completion before deadlines slip.</p>
              </div>
              <div className="col-lg-7">
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <div className="h-100 border rounded p-4">
                      <h5 className="bold font__size--20 text__20-1024 mb-2 color__white">Portfolio Signals</h5>
                      <ul className="list normal font__size--16 text__16-1024 color__white">
                        <li>Project performance</li>
                        <li>Deadline risk</li>
                        <li>Budget tracking</li>
                        <li>Progress reports</li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-6 mb-4">
                    <div className="h-100 border rounded p-4">
                      <h5 className="bold font__size--20 text__20-1024 mb-2 color__white">Delivery Trends</h5>
                      <ul className="list normal font__size--16 text__16-1024 color__white">
                        <li>Task completion</li>
                        <li>Resource usage</li>
                        <li>Milestone health</li>
                        <li>Time-to-completion</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Pricing />

        <section>
          <div className="container">
            <div className="text-center mb-5">
              <div className="wrapper__point justify-content-center mb-4">
                <div className="dot"></div>
                <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Core Features</h5>
              </div>
              <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm">Built For Corporate Project Execution</h2>
              <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">PavilionManager gives medium to large teams a practical way to plan work, assign responsibilities, manage resources and measure delivery progress.</p>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Task Assignment</h5>
                  <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Assign work to team members, clarify ownership and track progress in real time.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Milestone Tracking</h5>
                  <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Monitor key dates, project timelines and major delivery checkpoints.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Resource Allocation</h5>
                  <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Plan team capacity and allocate people, time and budget more effectively.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Team Collaboration</h5>
                  <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Use shared workspaces, file sharing and communication tools to keep teams aligned.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Project Analytics</h5>
                  <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Generate reports on project performance, budget tracking and time-to-completion.</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-4">
                <div className="wrapper__card-included h-100">
                  <h5 className="bold font__size--20 text__20-1024 mb-2">Workflow Visibility</h5>
                  <p className="normal font__size--16 text__16-1024 color__gray-2 mb-0">Improve visibility across departments and reduce the risk of missed deadlines.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container text-center">
            <div className="wrapper__point justify-content-center mb-4">
              <div className="dot"></div>
              <h5 className="mb-0 ml-2 color__blue semi-bold font__size--16 text__16-1024">Built for</h5>
            </div>
            <h1 className="semi-bold font__size--32 text__32-1024 text__32-xs mb-5">"A corporate project and task management solution for teams <br className="d-none d-xl-block" /> that need clearer ownership, better collaboration, stronger resource <br className="d-none d-xl-block" /> planning and reliable project visibility."</h1>

            <h5 className="semi-bold font__size--20 text__20-1024 mb-4">Made for project managers, teams and department heads</h5>
            {/* <div className="wrapper__logo-wrap flex-xl-nowrap flex-wrap d-flex align-items-center justify-content-center">
              <img className="mb-3" src="./../images/Company logo.png" alt="" />
              <img className="mb-3" src="./../images/Company logo (1).png" alt="" />
              <img className="mb-3" src="./../images/Company logo (2).png" alt="" />
              <img className="mb-3" src="./../images/Company logo (3).png" alt="" />
              <img className="mb-3" src="./../images/Company logo (4).png" alt="" />
              <img className="mb-3" src="./../images/Company logo (5).png" alt="" />
            </div> */}
          </div>
        </section>

        <Footer />
      </div>
    </Fragment>
  );
};

export default Index;
